import parse from 'html-react-parser';

function Article({ info }) {
  if (!info) return null;

  // Compatible with existing structure where Article content is in info.extra.rendered
  const content = info?.extra || '';

  return (
    <div className="justify article-rich" style={{ width: '100%' }}>
      {typeof content === 'string' ? parse(content) : null}
    </div>
  );
}

export default Article;
